import {Component} from "@angular/core";

@Component({
    selector: "wbo-search-form-fields",
    styleUrls: ["./search-form-fields.component.scss"],
    templateUrl: "./search-form-fields.component.html"
})
export class SearchFormFieldsComponent {

}
